import React, { useState, useEffect, useRef, useCallback } from 'react';
import './SearchBar.css';
import './SearchResults.css';
import SearchResults from './SearchResults';
import quotesData from './quotes.json';

const SearchBar = ({ onRecommendationsFetched, initialSearchTerm, showQuote = true, onSearch, watchlistMatches }) => {
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm || '');
  const [searchResults, setSearchResults] = useState([]);
  const [quoteText, setQuoteText] = useState('');
  const [randomImageIndex, setRandomImageIndex] = useState(1);

  useEffect(() => {
    // Get a random quote and image on mount (live search disabled)
    const randomQuote = quotesData[Math.floor(Math.random() * quotesData.length)];
    const formattedQuote = randomQuote ? `“${randomQuote.q}” - ${randomQuote.t}` : '';
    setQuoteText(formattedQuote);
    const imageIndex = Math.floor(Math.random() * 8) + 1;
    setRandomImageIndex(imageIndex);
  }, []); // This effect runs only once on component mount

  useEffect(() => {
    if (initialSearchTerm) {
      setSearchTerm(initialSearchTerm);
    }
  }, [initialSearchTerm]);

  const updateUI = (message, spinnerVisibility = 'none') => {
    document.getElementById("searching-txt").innerText = message;
    document.getElementById("searching-spinner").style.display = spinnerVisibility;
  }

  const fetchAPI = (endpoint) => {
    updateUI('Fetching...', 'inline-block');
    fetch(endpoint)
      .then(response => response.json())
      .then(data => {
        setSearchResults(data.searchResults.results);
        updateUI(data.searchResults.results.length > 0 ? `Results for '${initialSearchTerm}'` : `No results found for '${searchTerm}'`);
      })
      .catch(error => {
        console.error('Error:', error);
        setSearchResults([]);
        updateUI('Failed to fetch data.');
      });
  };

  const executeSearch = (term = searchTerm) => {
    if (!term) return;
    const endpoint = `/search?title=${encodeURIComponent(term)}`;
    initialSearchTerm = term;
    setSearchResults([]);
    fetchAPI(endpoint);
  };

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    if (onSearch) onSearch(term);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      executeSearch();
    }
  };

  const clearSearchResults = () => {
    updateUI('');
    setSearchResults([]);
    setSearchTerm(''); // Clear search term
    document.getElementById("search-textfield").placeholder = 'Search for TV shows and movies'; // Reset placeholder when clearing results
  }

  return (
    <div className="search-wrapper"> 
        <div className="search-bar" style={{ paddingTop: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
          <input
            id="search-textfield"
            type="text"
            className="form-control"
            placeholder="Search for TV shows and movies"
            value={searchTerm}
            style={{ borderColor: "gray", color: "gray", backgroundColor: "black", fontSize: ".9em", width: "100%" }}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
          />
          {searchTerm.length > 0 ? (
            <i className="fa fa-times-circle" style={{ color: "#ccc", cursor: "pointer", fontSize: "1.2em" }} onClick={clearSearchResults}></i>
          ) : (
            <i className="fa fa-search" style={{ color: "#ccc", fontSize: "1.2em" }}></i>
          )}
        </div> 
        {showQuote && quoteText && (
          <div
            className="quote-display"
            style={{
              backgroundImage: `url("/static/images/quick_picks_${randomImageIndex}.png")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              padding: "0px",
              borderRadius: "8px",
              color: "white",
              position: "relative"
            }}
          >
            <div style={{ backgroundColor: "rgba(0,0,0,0.6)", padding: "20px", borderRadius: "8px" }}>
              <span
                className="quote-text"
                style={{
                  fontSize: "1.8rem",
                  fontWeight: "600",
                  color: "#f1f1f1"
                }}
              >
                <i className="fas fa-quote-left quote-icon" aria-hidden="true"></i>
                {quoteText.split('” -')[0].replace(/^“/, '').trim()}
                <i className="fas fa-quote-right quote-icon" aria-hidden="true"></i>
                <span
                  className="quote-source"
                  style={{
                    fontSize: "0.9rem",
                    opacity: 0.8,
                    marginLeft: "1px",
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                  onClick={() => executeSearch(quoteText.split('” -')[1].trim())}
                >
                  {'— ' + quoteText.split('” -')[1]}
                </span>
              </span>

            </div>
          </div>
        )}

      
      <span style={{position:"relative", marginLeft:"15px"}} id="searching-txt"></span>
      <i className="fas fa-refresh fa-spin" id="searching-spinner"></i>
      <SearchResults
        results={searchResults}
        watchlistMatches={watchlistMatches}
        onRecommendationsFetched={onRecommendationsFetched}
        fetchRecommendations={fetchAPI}
      />
    </div>
  );
};

export default SearchBar;
